<div class="addcontact-container dialog">
  <button mat-button mat-dialog-close class="dialog__close" (click)="onClose()">
    <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon><span>{{ 'shared.close' | translate }}</span>
  </button>
  <div mat-dialog-title>
    <div class="addcontact-title">
      <div class="title-search">
        <div class="help">{{ 'searchContact.addContacts' | translate }}</div>
      </div>
    </div>
  </div>

  <div mat-dialog-content class="dialog-content">
    <div class="note">{{ 'searchContact.note' | translate }}</div>
    <div class="search-contact-box">
      <div class="searchcontact-input">
        <div class="addcontact-search">
          <mat-form-field appearance="outline">
            <input
              matInput
              #searchBox
              class="searchBox"
              [formControl]="searchUser"
              type="search"
              [placeholder]="'recordsSearch.searchConatcts' | translate"
              />
              <i class="fa fa-search searchIcon"></i>
            </mat-form-field>
          </div>
        </div>

        <div class="add-contact-dropdowns">
          <div>
            <label>{{ 'admin.country' | translate | titlecase }}</label>
          </div>
          <mat-form-field class="select add-contact-dropdown" appearance="outline">
            <mat-select
              disableOptionCentering
              panelClass="languagedrop-position"
              id="country"
              [value]="selectedCountry"
              [placeholder]="selectedCountry"
              (selectionChange)="catalogSelection($event)"
              >
              @for (item of countriesCatalog; track item) {
                <mat-option [ngClass]="'select-option'" [value]="item.value">
                  {{ item.label | uppercase }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="contact-checkbox">
          <mat-checkbox (change)="searchContacts()" [(ngModel)]="cbreOnly">
            {{ 'searchContact.cbreOnly' | translate }}
          </mat-checkbox>
        </div>
      </div>

      @for (contact of contactList; track contact; let i = $index) {
        <div class="contact-card">
          <div class="circle-container" [ngStyle]="{ 'background-color': i | getColor }">
            <span>{{ contact.name | getContactInitials }}</span>
          </div>
          <div class="content-wrapper">
            @if (contact.name) {
              <div class="contact-title">{{ contact.name }}</div>
            }
            @if (contact.role) {
              <div class="email">{{ contact.role }}</div>
            }
            @if (contact.phone) {
              <div class="email">{{ contact.phone }}</div>
            }
            @if (contact.email) {
              <div class="email">{{ contact.email }}</div>
            }
          </div>
          <div>
            <div class="contact-bgcolor">
              <div class="contactCheck">
                <div>
                  <!-- max 6 contacts can be selected -->
                  <mat-checkbox
                    [disabled]="!contact.checked && selectedContacts.length === 6"
                    [(ngModel)]="contact.checked"
                    (change)="contactChecked($event.checked, contact.id)"
                  ></mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div mat-dialog-actions>
      <button class="btn-submit" (click)="onCreate()">{{ 'searchContact.save' | translate }}</button>
    </div>
  </div>
